module.exports = __webpack_public_path__ + "img/preview.2adcce68.png";